import { forwardRef, type CSSProperties, type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

/**
 * Grade técnica desenhada do Design System (ADR-0065): dois `linear-gradient`
 * de 1px, células quadradas de 26–80px, tinta clara sobre o ground. É o fundo
 * de trabalho da mesa de análise e do hero do login — não é decoração, é a
 * referência métrica que o blueprint pressupõe.
 *
 * A cor vem da var `--grid` (tinta a 6% achatada no ground), a mesma que a F1
 * declarou; `strong` usa `--grid-strong` para a grade de destaque.
 */

export interface TechGridProps extends HTMLAttributes<HTMLDivElement> {
  /** Lado da célula em px. Default 26 (mesa); o hero do login usa 80. */
  cell?: number;
  /** Grade de destaque (`--grid-strong`) em vez da padrão. */
  strong?: boolean;
}

export const TechGrid = forwardRef<HTMLDivElement, TechGridProps>(function TechGrid(
  { cell = 26, strong = false, className, style, children, ...props },
  ref,
) {
  const cor = strong ? 'oklch(var(--grid-strong))' : 'oklch(var(--grid))';
  const grade: CSSProperties = {
    backgroundImage: `linear-gradient(to right, ${cor} 1px, transparent 1px), linear-gradient(to bottom, ${cor} 1px, transparent 1px)`,
    backgroundSize: `${cell}px ${cell}px`,
    ...style,
  };

  return (
    <div
      ref={ref}
      data-tech-grid={cell}
      className={cn('relative', className)}
      style={grade}
      {...props}
    >
      {children}
    </div>
  );
});
